import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-profile-select-modal',
  templateUrl: './profile-select-modal.component.html',
  styleUrls: ['./profile-select-modal.component.scss'],
})
export class ProfileSelectModalComponent implements OnInit {
  constructor(private modalCtrl: ModalController, protected readonly translate: TranslateService) {}

  @Input() listData: any[] = [];

  @Input() selectedItem: any;

  filteredItems: any[] = [];

  ngOnInit() {
    this.filteredItems = [...this.listData];
    this.selectedItem = undefined;
  }

  cancel() {
    this.modalCtrl.dismiss(null, 'cancel').then();
  }

  onSelect(event: any) {
    this.selectedItem = event.detail.value;
  }

  save() {
    this.modalCtrl.dismiss(this.selectedItem, 'save').then();
  }

  searchbarInput(event: any) {
    this.filterList(event.target.value);
  }

  filterList(searchQuery: string | undefined) {
    if (searchQuery === undefined) {
      this.filteredItems = [...this.listData];
    } else {
      const normalizedQuery = searchQuery.toLowerCase();
      this.filteredItems = this.listData.filter((item) => {
        return item.name.toLowerCase().includes(normalizedQuery);
      });
    }
  }
}
